/**
 * Redimensiona/recodifica una foto de evidencia a JPEG liviano antes de
 * subirla (HU-008 Fase 7) — usa <canvas>, nativo del navegador, sin
 * librería nueva. 1600px de lado mayor conserva resolución de sobra para
 * ver el detalle de una incidencia; lo que se reduce es el peso real que
 * viaja por la red, no la nitidez percibida. No aplica a video/audio: el
 * backend ya los procesa con ffmpeg (pipeline existente).
 */
export const comprimirImagen = (blob, maxDimension = 1600, calidad = 0.8) =>
  new Promise((resolve) => {
    const img = new Image();
    const url = URL.createObjectURL(blob);
    img.onload = () => {
      URL.revokeObjectURL(url);
      const escala = Math.min(1, maxDimension / Math.max(img.width, img.height));
      const canvas = document.createElement('canvas');
      canvas.width = Math.round(img.width * escala);
      canvas.height = Math.round(img.height * escala);
      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
      canvas.toBlob((comprimido) => resolve(comprimido || blob), 'image/jpeg', calidad);
    };
    // Si la imagen no carga (formato raro, blob corrupto), se sube tal cual
    // en vez de bloquear el reporte por un problema de compresión.
    img.onerror = () => resolve(blob);
    img.src = url;
  });
